import { Box } from "@mui/material";
import { forwardRef } from "react";

interface MapContainerProps {}

export const MapContainer = forwardRef<HTMLDivElement, MapContainerProps>(
  (_, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          width: "100%",
          height: "100%",
          "& .mapboxgl-ctrl-logo": {
            display: "none",
          },
        }}
      />
    );
  }
);

MapContainer.displayName = "MapContainer";

